import { createSelector } from '@ngrx/store';

import { getCurrentRoute } from '../getCurrentRoute';

export const routeIsOrderConfirmationPage = (regExp: RegExp = /\/order-confirmation/i) =>
    createSelector(getCurrentRoute, (route) => (route === null ? null : route.url.match(regExp) !== null));
